import { Menu } from "../model/security/menu.model";

/**
 * ¿El usuario tiene una hoja de menú que corresponda a esta ruta?
 *
 * Compara contra el factory de cada hoja, contra padre/hoja concatenados
 * y contra su `ruta` (la columna guarda la ruta completa histórica, p. ej.
 * 'DENUNCIAS/dashboard' para la hoja cuyo factory es sólo 'dashboard'),
 * sin importar mayúsculas ni diagonales sobrantes: es la misma pregunta
 * que responde el backend con cuentaAccesoMenuXUsuario, y la usa Inicio
 * para decidir qué accesos directos y qué pestañas mostrar.
 */
export function tieneAccesoMenu(menus: Menu[] | null | undefined, ruta: string): boolean {
  const rutaNormalizada = normalizarRuta(ruta);
  return (menus || []).some((menu) => coincide(menu, rutaNormalizada));
}

function coincide(menu: Menu, rutaNormalizada: string, parentFactory = ""): boolean {
  const factoryActual = [parentFactory, menu?.factory].filter(Boolean).join("/");
  if (
    normalizarRuta(menu?.factory) === rutaNormalizada ||
    normalizarRuta(factoryActual) === rutaNormalizada ||
    (!!menu?.ruta && normalizarRuta(menu.ruta) === rutaNormalizada)
  ) {
    return true;
  }
  return (menu?.hijos || []).some((hijo) => coincide(hijo, rutaNormalizada, factoryActual));
}

function normalizarRuta(ruta: string | null | undefined): string {
  return (ruta || "")
    .split("/")
    .map((segmento) => segmento.trim())
    .filter(Boolean)
    .join("/")
    .toUpperCase();
}
